let openTokKey = null;
let stripePublishableKey = null;

const isDev = import.meta.env.DEV;
const isStaging =
  import.meta.env.MODE === 'staging' || import.meta.env.MODE?.includes('testenv');
const isProduction = !(isDev || isStaging);

if (isDev || isStaging) {
  openTokKey = '46282432';
  stripePublishableKey =
    'pk_test_51HfSVrCLhk5LPq5G6xXGWVjwo0VsapAFAu265AkaxSSI7GFYa7M9GnH6C9PaSjrh0REvD4dMARolX6WZAGLQp50u00iaa83cqO';
} else {
  openTokKey = '46187592';
  stripePublishableKey =
    'pk_live_51HfSVrCLhk5LPq5GerwH9nouTYUi5dNLaJknt7OtRoifZdc8m2BWFjhZT4KLaymMU1kgzkHJ2Kl41iypgpvHiRQO00w2wsvga2';
}

const devHostname = import.meta.env.VITE_DEV_SERVER_PROXY;
const mixpanelToken = isProduction
  ? '30137be7dac047d9eeeff55e48b07616'
  : 'be4fd18969ada70ab3379a294c154463';

// exports ----------------------
export const IS_DEV = isDev;
export const IS_STAGING = isStaging;
export const IS_PRODUCTION = isProduction;
export const APP_ID = 'leap.cuemath.com';
export const SENTRY_DSN = 'https://3629598e1ca648dbb845007d23cf47d3@sentry.io/1331407';
export const CUEMATH_APP_URL = 'https://www.cuemath.com/apps/cuemath';
export const DEV_HOST_NAME = devHostname;
export const OPEN_TALK_KEY = openTokKey;
export const STRIPE_PUBLISHABLE_KEY = stripePublishableKey;
export const MIXPANEL_TOKEN = mixpanelToken;
export const IS_APP_RUNNING_IN_RN = !!window.ReactNativeWebView;
export const PLATFORM = {
  APP: 'app',
  WEB: 'web',
} as const;
export const GOOGLE_CLIENT_ID =
  '355853530189-nkmsfl8ph0k6qim8fshin56p3u18cf0o.apps.googleusercontent.com';
export const APPLE_CLIENT_ID = 'com.cuelearn.leap';
export const APPLE_JS_SDK_URL =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
